// @ts-nocheck

import recomputeNextBoomBasketState from '../../../modules/boom/utils/recomputeNextBoomBasketState';
import recomputeNextGRBasketState from '../../../modules/gift-race/utils/recomputeNextGRBasketState';
import recomputeNextMPBasketState from '../../../modules/monopoly/utils/recomputeNextMPBasketState';

const recomputeBasketStateForOperations = (nextBasketState, globalState) => {
  let nextState = nextBasketState;
  nextState = recomputeNextMPBasketState(nextState, globalState);
  nextState = recomputeNextBoomBasketState(nextState, globalState);
  nextState = recomputeNextGRBasketState(nextState, globalState);
  return nextState;
};

export default recomputeBasketStateForOperations;
